export default __webpack_public_path__ + "static/media/shopify.5dc92f96.svg";